export default __webpack_public_path__ + "static/ledger-de1875b52af3786624287b66bc23e19b.png";